var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#757CA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1495 18.228H14.7703L13.9387 21H12.3811L15.6019 11.2848H17.3707L20.5915 21H18.9679L18.1495 18.228ZM17.7799 17.0268L17.3971 15.72C17.0671 14.664 16.7767 13.5948 16.4731 12.486H16.4203C16.1431 13.5948 15.8395 14.664 15.5227 15.72L15.1267 17.0268H17.7799Z",
    fill: "#011136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEn);
export default __webpack_public_path__ + "static/media/Icon_En.22cba47c654fee174bf03cb7b8b629b6.svg";
export { ForwardRef as ReactComponent };